import { postPresence } from '$lib/apis/pusher';
import { PRESENCE_API_REFRESH } from '$lib/refreshIntervals';
import type { addressType } from '$lib/types/util';

// presence refresh
let presenceRefreshInterval: ReturnType<typeof setInterval>;

export function setupPresenceApiRefresh(smartContractWalletAddress: addressType) {
	if (presenceRefreshInterval) clearInterval(presenceRefreshInterval);
	postPresence(smartContractWalletAddress);

	presenceRefreshInterval = setInterval(() => {
		postPresence(smartContractWalletAddress);
	}, PRESENCE_API_REFRESH);
}
